import type { PageSegmentLoadMetric } from '@atlassian/browser-metrics/page-segment-load';

import { createPageSegmentLoadMetric } from '@confluence/browser-metrics/entry-points/metricConfigs.ts';
import {
	SPACE_NAVIGATION_SEGMENT_KEY,
	SPACE_APPS_SEGMENT_KEY,
} from '@confluence/browser-metrics/entry-points/metric-keys.ts';

import { ssrConfig } from '../ssrConfig.ts';

export const SPACE_NAVIGATION_METRIC: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: SPACE_NAVIGATION_SEGMENT_KEY,
	ssr: ssrConfig(),
});

export const SPACE_APPS_METRIC: PageSegmentLoadMetric = createPageSegmentLoadMetric({
	key: SPACE_APPS_SEGMENT_KEY,
	ssr: ssrConfig(),
});
